import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import { SelectProps } from "@cofano/cck/Select/Select";

const ProductLoadingTypeSelect = ({ value, onChange }: Omit<SelectProps<string, false>, "fetchOptions">) => {
	return (
		<Select
			value={value}
			fetchOptions={[ "SOLID_BULK", "BREAK_BULK", "LIQUID_BULK", "CONTAINER" ]}
			getOptionLabel={opt => intl.formatMessage({ id: `PRODUCTS_${opt}` })}
			multiple={false}
			onChange={onChange}
			disableSearch />
	);
};

export default ProductLoadingTypeSelect;
